module.exports = __webpack_public_path__ + "img/vuejs.d66a6849.png";